// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "lineUboDeclaration";
const shader = `layout(std140,column_major) uniform;
#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
// Sideeffect
if (!ShaderStore.IncludesShadersStore[name]) {
    ShaderStore.IncludesShadersStore[name] = shader;
}
ShaderStore._PendingIncludesLoaders.push(() => Promise.all([
    import("./sceneUboDeclaration"),
    import("./meshUboDeclaration")
]));
/** @internal */
export const lineUboDeclaration = { name, shader };
